/* eslint-disable no-empty-pattern */
import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";

import * as Regex from 'utils/validations';
import { DataContext } from 'providers/data';
import { DataTypesOfAddress } from 'core/typesOfAddress';
import { ParamsDataCustomerForEdit } from 'utils/typeServices';

import { Box, Typography, Checkbox, Collapse } from '@mui/material';

import Modals from 'components/views/Modals';
import Input from 'components/views/form/Input';
import Select from 'components/views/form/Select';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import { ReactComponent as IcDeleteOutlined } from 'assets/icons/ic-delete-outlined.svg';

import { Label } from '../styles';

type ParamsCustomerForEdit = {
    dataCustomerForEdit: ParamsDataCustomerForEdit;
}

const BillingAddress = ({ dataCustomerForEdit }: ParamsCustomerForEdit) => {
    const { register, setValue, watch } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [addContact, setAddContact] = useState(false);
    const [isEditInfos, setIsEditInfos] = useState(false);
    const [showAddContact, setShowAddContact] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [lengthDelete, setLengthDelete] = useState(0);
    const [showModalSuccess, setShowModalSuccess] = useState(false);
    const [showModalError, setShowModalError] = useState(false);
    const [msgModalError, setMsgModalError] = useState('');
    const [showModalDeleted, setShowModalDeleted] = useState({
        show: false,
        indexDeleted: 0
    });

    const [typeSelected, setTypeSelected] = useState({
        text: '',
        value: ''
    });
    const [revenueAdd, setRevenueAdd] = useState(false);
    const [collectionAdd, setCollectionAdd] = useState(false);

    const { dataByZipCode, updatePerfil, customerCars, handleGetByZipCode, handlePostEditCustomerAppAddress, handleResetUpdatePerfil } = useContext(DataContext);

    const cepAdd = watch('cepAdd', '');
    const numberAdd = watch('numberAdd', '');
    const districtAdd = watch('districtAdd', '');
    const districtAddMb = watch('districtAddMb', '');
    const complementAdd = watch('complementAdd', '');
    const fullAddressAdd = watch('fullAddressAdd', '');

    const handleClearSelected = (type: boolean) => {
        if (type) {
            dataCustomerForEdit.addressList.map(({ }, index) => setValue(`collection${index}`, false))
        } else {
            dataCustomerForEdit.addressList.map(({ }, index) => setValue(`revenue${index}`, false))
        }
    }

    const handleClearAddAddress = () => {
        setValue('cepAdd', '');
        setValue('numberAdd', '');
        setValue('districtAdd', '');
        setValue('districtAddMb', '');
        setValue('complementAdd', '');
        setValue('fullAddressAdd', '');
        setTypeSelected({ text: '', value: '' });
        setRevenueAdd(false);
        setCollectionAdd(false);

        if (dataByZipCode) {
            dataByZipCode.cityName = '';
            dataByZipCode.district = '';
            dataByZipCode.stateName = '';
            dataByZipCode.fullAddress = '';
        }
    }

    const handleCheckType = (type: number) => {
        switch (type) {
            case 1:
                return {
                    text: 'RESIDENCIAL',
                    value: 1
                }
            case 2:
                return {
                    text: 'COMERCIAL',
                    value: 2
                }
            case 3:
                return {
                    text: 'FATURAMENTO',
                    value: 3
                }
            case 4:
                return {
                    text: 'ENTREGA',
                    value: 4
                }
            case 5:
                return {
                    text: 'INSTALAÇÃO',
                    value: 5
                }
            case 6:
                return {
                    text: 'CORRESPONDÊNCIA',
                    value: 6
                }
            case 8:
                return {
                    text: 'REMESSA',
                    value: 8
                }
        }
    }

    const handlePostEditCustomerAppAddressState = ({ flPerfil = false, validSecurityCode }: { flPerfil: boolean, validSecurityCode?: boolean }) => {
        if (validSecurityCode && customerCars.find(({ CODIGO_SEGURADORA }) => 230146 === CODIGO_SEGURADORA)) {
            setShowModal(true);
            return;
        }

        setIsLoading(true);
        let emptFields = dataCustomerForEdit.addressList.filter(({ city, cityId, district, id, isCEPPernoite, startDate, state, street, zipcode }, index) => (!zipcode || !watch(`number${index}`).replace('_', '').match(Regex.hsNumber)));

        if (emptFields.length > 0 && !addContact) {
            setShowModalError(true);
            setMsgModalError('O campo "número" é obrigatório.');
            setIsLoading(false);
            return false

        } else {
            if ((dataCustomerForEdit.addressList.find(({ }, index) => watch(`revenue${index}`)) && dataCustomerForEdit.addressList.find(({ }, index) => watch(`collection${index}`))) || (collectionAdd && revenueAdd)) {

                let addressListAux = dataCustomerForEdit.addressList.map(({ city, cityId, district, id, isCEPPernoite, startDate, state, street, zipcode }, index) => {

                    return {
                        addressType: parseFloat(watch(`addressType${index}[value]`)),
                        city,
                        cityId,
                        collection: watch(`collection${index}`),
                        deleted: watch(`deleted${index}`),
                        district: district ? district : watch(`district${index}`) ? watch(`district${index}`) : watch(`districtMb${index}`),
                        id,
                        isCEPPernoite: flPerfil && (index === 0) ? true : false,
                        number: parseFloat(watch(`number${index}`)),
                        complement: watch(`complement${index}`),
                        revenue: watch(`revenue${index}`),
                        startDate,
                        state,
                        street: street ? street : watch(`fullAddress${index}`),
                        zipcode,
                    };
                })

                if (addContact && dataByZipCode) {
                    let dateNow = new Date();

                    addressListAux.push({
                        id: 0,
                        addressType: parseFloat(typeSelected.value),
                        city: dataByZipCode?.cityName,
                        cityId: dataByZipCode?.cityId,
                        collection: collectionAdd,
                        deleted: false,
                        district: dataByZipCode?.district ? dataByZipCode?.district : districtAdd ? districtAdd : districtAddMb,
                        isCEPPernoite: false,
                        number: parseFloat(numberAdd.replace(/[^0-9]/g, '')),
                        complement: complementAdd,
                        revenue: revenueAdd,
                        startDate: dateNow.toISOString(),
                        state: dataByZipCode?.stateName,
                        street: dataByZipCode?.fullAddress ? `${dataByZipCode?.type && `${dataByZipCode?.type} `} ${dataByZipCode?.fullAddress}` : fullAddressAdd,
                        zipcode: cepAdd.replace(/[^0-9]/g, ''),
                    });
                }

                handlePostEditCustomerAppAddress({
                    token: localStorage.getItem('token')!,
                    body: {
                        id: dataCustomerForEdit.id,
                        flAtualizaPerfil: flPerfil,
                        addressList: addressListAux
                    }
                });
            } else {
                setShowModalError(true);
                setMsgModalError('O campo cobrança e faturamento deve estar selecionado em ao menos um endereço.');
                setIsLoading(false);
                return false
            }
        }
    }

    const handleChecked = (typeCollection: boolean, indexSelected: number) => {
        if (typeCollection) {
            if (watch(`collection${indexSelected}`)) {
                setValue(`collection${indexSelected}`, false);
            } else {
                setValue(`collection${indexSelected}`, true);
                dataCustomerForEdit.addressList.map(({ }, index) => index !== indexSelected && setValue(`collection${index}`, false))
            }
        } else {
            if (watch(`revenue${indexSelected}`)) {
                setValue(`revenue${indexSelected}`, false);
            } else {
                setValue(`revenue${indexSelected}`, true);
                dataCustomerForEdit.addressList.map(({ }, index) => index !== indexSelected && setValue(`revenue${index}`, false))
            }
        }
    }

    const getAddress = (idIndex: number, cep: string) => {
        if (cep?.match(Regex.cep)) {
            handleGetByZipCode({
                token: localStorage.getItem('token')!,
                cep: cep,
                indexId: idIndex,
            });
        }
    }

    useEffect(() => {
        if (dataByZipCode && dataByZipCode?.indexId !== undefined) {
            dataCustomerForEdit.addressList[dataByZipCode?.indexId].zipcode = dataByZipCode.cep;
            dataCustomerForEdit.addressList[dataByZipCode?.indexId].city = dataByZipCode.cityName;
            dataCustomerForEdit.addressList[dataByZipCode?.indexId].cityId = dataByZipCode.cityId;
            dataCustomerForEdit.addressList[dataByZipCode?.indexId].district = dataByZipCode.district;
            dataCustomerForEdit.addressList[dataByZipCode?.indexId].state = dataByZipCode.stateName;
            dataCustomerForEdit.addressList[dataByZipCode?.indexId].street = dataByZipCode.fullAddress;

            dataCustomerForEdit.addressList.map(({ zipcode, number, deleted, collection, revenue, addressType, id, complement }, index) => (
                // eslint-disable-next-line no-sequences
                setValue(`id${index}`, id),
                setValue(`zipcode${index}`, zipcode),
                setValue(`addressType${index}`, handleCheckType(addressType)),
                setValue(`deleted${index}`, deleted),
                setValue(`number${index}`, `${number}`),
                setValue(`complement${index}`, complement || ''),
                setValue(`collection${index}`, collection),
                setValue(`revenue${index}`, revenue)
            ));
        } else if (dataByZipCode === false) {
            setShowModalError(true);
            setMsgModalError('Digite um cep valido.');
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataByZipCode])

    useEffect(() => {
        if (cepAdd?.match(Regex.cep)) {
            handleGetByZipCode({
                token: localStorage.getItem('token')!,
                cep: cepAdd
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cepAdd]);

    useEffect(() => {
        setTimeout(() => {
            setShowAddContact(addContact);
        }, 550);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addContact]);

    useEffect(() => {
        if (dataCustomerForEdit) {
            dataCustomerForEdit.addressList.map(({ zipcode, number, deleted, collection, revenue, addressType, id, complement }, index) => (
                // eslint-disable-next-line no-sequences
                setValue(`id${index}`, id),
                setValue(`zipcode${index}`, zipcode),
                setValue(`addressType${index}`, handleCheckType(addressType)),
                setValue(`deleted${index}`, deleted),
                setValue(`number${index}`, `${number}`),
                setValue(`complement${index}`, complement || ''),
                setValue(`collection${index}`, collection),
                setValue(`revenue${index}`, revenue)
            ));
            setIsLoading(false);
            setAddContact(false);
            setIsEditInfos(false);
            setLengthDelete(dataCustomerForEdit.addressList.length);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataCustomerForEdit]);

    useEffect(() => {
        if (updatePerfil?.type !== 'default') {
            setIsLoading(false);
            if (updatePerfil?.showModal) {
                setShowModalSuccess(true);
            }

            if (updatePerfil?.flPerfil) {
                window.location.reload();
            }
        }
    }, [updatePerfil]);

    return (
        <Box sx={{ width: '100%' }}>
            <Collapse in={addContact ? showAddContact : addContact}>
                <Typography fontWeight={600} fontSize='1.25rem' marginBottom='1.06rem' color='primary.light'>
                    Novo contato:
                </Typography>
            </Collapse>
            <Collapse in={!addContact ? !showAddContact : !addContact}>
                <Typography fontSize='.875rem' sx={{ fontWeight: { xs: '400', md: '600' }, marginBottom: { xs: '1.3175rem', md: '2.125rem' } }}>
                    Alterações efetuadas não refletem no CEP pernoite do seu veículo.
                </Typography>
            </Collapse>

            <Collapse in={addContact ? showAddContact : addContact}>
                <Box sx={{ maxWidth: '35.43rem', '#box-input': { height: '4.125rem' } }}>
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '6.8rem calc(100% - 8rem)', md: '9rem auto 4.75rem' },
                        justifyContent: 'space-between',
                        gap: { xs: '1rem', md: '' },
                        alignItems: 'flex-start',
                        marginBottom: '1.5625rem'
                    }}>
                        <Input
                            name='cepAdd'
                            label='CEP do cadastro'
                            placeholder='00000-000'
                            maskHolder='99999-999'
                            mask
                            type='tel'
                            disabled={!isEditInfos}
                            register={{ ...register("cepAdd", { pattern: Regex.cep }) }} />
                        <Label>
                            {dataByZipCode && dataByZipCode?.fullAddress ?
                                <>
                                    <p className='title'>
                                        Logradouro
                                    </p>
                                    <p className='description'>
                                        {dataByZipCode && dataByZipCode?.type && <>{dataByZipCode?.type}&nbsp;</>}
                                        {dataByZipCode && dataByZipCode?.fullAddress}
                                    </p>
                                </>
                                :
                                <Input
                                    name='fullAddressAdd'
                                    label='Logradouro'
                                    type='text'
                                    placeholder=''
                                    disabled={!isEditInfos}
                                    register={{ ...register("fullAddressAdd", { pattern: Regex.city }) }} />
                            }
                        </Label>
                        <Box sx={{ maxWidth: '5rem' }}>
                            <Input
                                name='numberAdd'
                                label='Número'
                                placeholder='00'
                                maskHolder='99999'
                                disabled={!isEditInfos}
                                type='tel'
                                mask
                                register={{ ...register("numberAdd", { pattern: /^[0-9]{1}$/i }) }}
                            />
                        </Box>
                        <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'space-between', marginLeft: '-2rem' }}>
                            <Label>
                                <p className='title'>
                                    Cidade
                                </p>
                                <p className='description'>
                                    {dataByZipCode && dataByZipCode?.cityName}
                                </p>
                            </Label>
                            <Label sx={{ 'input': { maxWidth: { xs: '5.5rem', md: '8rem' } } }}>
                                {dataByZipCode && dataByZipCode?.district ?
                                    <>
                                        <p className='title'>
                                            Bairro
                                        </p>
                                        <p className='description'>
                                            {dataByZipCode?.district}
                                        </p>
                                    </>
                                    :
                                    <Input
                                        name='districtAddMb'
                                        label='Bairro'
                                        type='text'
                                        placeholder=''
                                        disabled={!isEditInfos}
                                        register={{ ...register("districtAddMb", { pattern: Regex.city }) }} />
                                }
                            </Label>
                            <Label>
                                <p className='title'>
                                    UF
                                </p>
                                <p className='description'>
                                    {dataByZipCode && dataByZipCode?.stateName}
                                </p>
                            </Label>
                        </Box>
                    </Box>
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'space-between', marginBottom: '1.5625rem', gap: { xs: '1rem', md: '' } }}>
                        <Label>
                            <p className='title'>
                                Cidade
                            </p>
                            <p className='description'>
                                {dataByZipCode && dataByZipCode?.cityName}
                            </p>
                        </Label>
                        <Label>
                            {dataByZipCode && dataByZipCode?.district ?
                                <>
                                    <p className='title'>
                                        Bairro
                                    </p>
                                    <p className='description'>
                                        {dataByZipCode?.district}
                                    </p>
                                </>
                                :
                                <Input
                                    name='districtAdd'
                                    label='Bairro'
                                    type='text'
                                    placeholder=''
                                    disabled={!isEditInfos}
                                    register={{ ...register("districtAdd", { pattern: Regex.city }) }} />
                            }
                        </Label>
                        <Label>
                            <p className='title'>
                                UF
                            </p>
                            <p className='description'>
                                {dataByZipCode && dataByZipCode?.stateName}
                            </p>
                        </Label>
                    </Box>
                    <Box>
                        <Input
                            name='complementAdd'
                            label='Complemento'
                            type='text'
                            placeholder=''
                            disabled={!isEditInfos}
                            register={{ ...register("complementAdd") }} />
                    </Box>
                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'calc(50% - .5rem) auto', md: '15.625rem auto auto' }, alignItems: 'flex-end', margin: '1.25rem 0 1.875rem', justifyContent: 'space-between' }}>
                        <Select
                            label='Tipo'
                            disabled={!isEditInfos}
                            itemSelected={typeSelected}
                            listItems={DataTypesOfAddress.map(({ phoneTypeText, phoneTypeId }) => {
                                return { text: phoneTypeText, value: `${phoneTypeId}` }
                            })}
                            onChangeSelected={(e) => setTypeSelected(e)}
                        />
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: '0', md: '1.68rem' } }}>
                            <Label sx={{ display: 'flex', alignItems: 'center', gap: '.5rem', paddingBottom: '.5rem' }}>
                                <Checkbox checked={collectionAdd} sx={{ padding: '3px 0 0' }} onClick={() => { setCollectionAdd(!collectionAdd); handleClearSelected(true); }} />
                                <p className='description'>
                                    Cobrança
                                </p>
                            </Label>
                            <Label sx={{ display: 'flex', alignItems: 'center', gap: '.5rem', paddingBottom: '.5rem' }}>
                                <Checkbox checked={revenueAdd} sx={{ padding: '3px 0 0' }} onClick={() => { setRevenueAdd(!revenueAdd); handleClearSelected(false); }} />
                                <p className='description'>
                                    Faturamento
                                </p>
                            </Label>
                        </Box>
                    </Box>
                </Box>
            </Collapse>

            <Collapse in={!addContact ? !showAddContact : !addContact}>
                {dataCustomerForEdit?.addressList?.map(({ street, city, district, state, zipcode, complement }, index) => (
                    !watch(`deleted${index}`) &&

                    <Box key={index} sx={{ display: 'flex', width: '100%', justifyContent: 'flex-start' }}>
                        <Box sx={{ borderTop: '2px solid #0C1C33', width: '100%', maxWidth: '35.43rem', '#box-input': { height: '4.125rem' } }}>
                            <Box sx={{ display: 'none' }}>
                                <Input
                                    name={`id${index}`}
                                    type='text'
                                    register={{ ...register(`id${index}`) }} placeholder={''} />
                            </Box>
                            <Typography fontSize='1.125rem' color='white' sx={{ padding: '4px .61rem 3px', backgroundColor: 'primary.main', width: 'fit-content', marginBottom: '1rem' }}>
                                {dataCustomerForEdit.addressList.length > 1 ?
                                    `Endereço ${index + 1}`
                                    :
                                    'Endereço'
                                }
                            </Typography>
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: { xs: '6.8rem calc(100% - 8rem)', md: '9rem auto 4.75rem' },
                                justifyContent: 'space-between',
                                gap: { xs: '1rem', md: '' },
                                alignItems: 'flex-start',
                                marginBottom: '1.5625rem'
                            }}>
                                {zipcode &&
                                    <Input
                                        name={`zipcode${index}`}
                                        label='CEP do cadastro'
                                        placeholder={`zipcode${index}`}
                                        maskHolder='99999-999'
                                        mask
                                        type='tel'
                                        disabled={!isEditInfos}
                                        register={{ ...register(`zipcode${index}`, { pattern: Regex.cep, onChange: (e) => getAddress(index, e.target.value) }) }} />
                                }
                                <Label>
                                    {street ?
                                        <>
                                            <p className='title'>
                                                Logradouro
                                            </p>
                                            <p className='description'>
                                                {street}
                                            </p>
                                        </>
                                        :
                                        <Input
                                            name={`fullAddress${index}`}
                                            label='Logradouro'
                                            type='text'
                                            placeholder=''
                                            disabled={!isEditInfos}
                                            register={{ ...register(`fullAddress${index}`, { pattern: Regex.city }) }} />
                                    }
                                </Label>
                                <Box sx={{ maxWidth: '5rem' }}>
                                    <Input
                                        name={`number${index}`}
                                        label='Número'
                                        placeholder={`number${index}`}
                                        maskHolder='99999'
                                        disabled={!isEditInfos}
                                        type='tel'
                                        mask
                                        register={{ ...register(`number${index}`, { pattern: /^[0-9]{1}$/i }) }}
                                    />
                                </Box>
                                <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'space-between', marginLeft: '-2rem' }}>
                                    <Label>
                                        <p className='title'>
                                            Cidade
                                        </p>
                                        <p className='description'>
                                            {city}
                                        </p>
                                    </Label>
                                    <Label sx={{ 'input': { maxWidth: { xs: '5.5rem', md: '8rem' } } }}>
                                        {district ?
                                            <>
                                                <p className='title'>
                                                    Bairro
                                                </p>
                                                <p className='description'>
                                                    {district}
                                                </p>
                                            </>
                                            :
                                            <Input
                                                name={`districtMb${index}`}
                                                label='Bairro'
                                                type='text'
                                                placeholder=''
                                                disabled={!isEditInfos}
                                                register={{ ...register(`districtMb${index}`, { pattern: Regex.city }) }} />
                                        }
                                    </Label>
                                    <Label>
                                        <p className='title'>
                                            UF
                                        </p>
                                        <p className='description'>
                                            {state}
                                        </p>
                                    </Label>
                                </Box>
                            </Box>
                            <Box sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'space-between', marginBottom: '1.5625rem', gap: { xs: '1rem', md: '' } }}>
                                <Label>
                                    <p className='title'>
                                        Cidade
                                    </p>
                                    <p className='description'>
                                        {city}
                                    </p>
                                </Label>
                                <Label sx={{ width: '51%' }}>
                                    {district ?
                                        <>
                                            <p className='title'>
                                                Bairro
                                            </p>
                                            <p className='description'>
                                                {district}
                                            </p>
                                        </>
                                        :
                                        <Input
                                            name={`district${index}`}
                                            label='Bairro'
                                            type='text'
                                            placeholder=''
                                            disabled={!isEditInfos}
                                            register={{ ...register(`district${index}`, { pattern: Regex.city }) }} />
                                    }
                                </Label>
                                <Label>
                                    <p className='title'>
                                        UF
                                    </p>
                                    <p className='description'>
                                        {state}
                                    </p>
                                </Label>
                            </Box>
                            <Box>
                                <Input
                                    name={`complement${index}`}
                                    label='Complemento'
                                    type='text'
                                    placeholder={`complement${index}`}
                                    disabled={!isEditInfos}
                                    register={{ ...register(`complement${index}`) }} />
                            </Box>
                            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'calc(50% - .5rem) auto', md: '15.625rem auto auto' }, alignItems: 'flex-end', margin: '1.25rem 0 1.875rem', justifyContent: 'space-between' }}>
                                <Select
                                    label='Tipo'
                                    disabled={!isEditInfos}
                                    itemSelected={watch(`addressType${index}`)}
                                    listItems={DataTypesOfAddress.map(({ phoneTypeText, phoneTypeId }) => {
                                        return { text: phoneTypeText, value: `${phoneTypeId}` }
                                    })}
                                    onChangeSelected={(e) => setValue(`addressType${index}`, e)}
                                />
                                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: '0', md: '1.68rem' } }}>
                                    <Label sx={{ display: 'flex', alignItems: 'center', gap: '.5rem', paddingBottom: '.5rem' }}>
                                        <Checkbox checked={watch(`collection${index}`) ? true : false} sx={{ padding: '3px 0 0' }} onClick={() => dataCustomerForEdit?.addressList.length === 1 && watch(`collection${index}`) ? {} : isEditInfos && handleChecked(true, index)} />
                                        <p className='description'>
                                            Cobrança
                                        </p>
                                    </Label>
                                    <Label sx={{ display: 'flex', alignItems: 'center', gap: '.5rem', paddingBottom: '.5rem' }}>
                                        <Checkbox checked={watch(`revenue${index}`) ? true : false} sx={{ padding: '3px 0 0' }} onClick={() => dataCustomerForEdit?.addressList.length === 1 && watch(`collection${index}`) ? {} : isEditInfos && handleChecked(false, index)} />
                                        <p className='description'>
                                            Faturamento
                                        </p>
                                    </Label>
                                </Box>
                            </Box>
                        </Box>
                        {lengthDelete > 1 && isEditInfos &&
                            <Box sx={{
                                position: { xs: 'absolute', md: 'relative' },
                                right: '0',
                                backgroundColor: 'white'
                            }}>
                                <Box sx={{
                                    cursor: 'pointer',
                                    marginLeft: { xs: '.75rem', md: '2rem' },
                                    width: { xs: '2rem', md: '2.5rem' },
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: { xs: '2rem', md: '2.5rem' },
                                    borderRadius: '100px',
                                    backgroundColor: 'error.main'
                                }}
                                    onClick={() => setShowModalDeleted({ show: true, indexDeleted: index, })}
                                >
                                    <IcDeleteOutlined />
                                </Box>
                            </Box>
                        }
                    </Box>
                ))}
            </Collapse>

            <Box sx={{ display: 'flex', gap: '1rem', 'button': { height: '2.5rem', width: '100%', maxWidth: { xs: '100%', md: '15.625rem' } } }}>
                <ButtonOutlined name={isEditInfos ? 'CANCELAR' : 'Editar'} onClick={() => { setIsEditInfos(!isEditInfos); setAddContact(false); handleClearAddAddress(); }} />
                <ButtonRectangle name={isEditInfos ? 'SALVAR DADOS' : 'ADICIONAR'} loadingBtn={isLoading} onClick={() => !isEditInfos ? (setAddContact(true), setIsEditInfos(true)) : handlePostEditCustomerAppAddressState({ flPerfil: false, validSecurityCode: true })} />
            </Box>

            <Modals open={showModal}>
                <Box sx={{ textAlign: 'center', width: '23.5rem' }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 1rem 1.125rem'>
                        <Typography fontSize='1.25rem' fontWeight={700}>
                            Esta alteração também se <br /> aplica ao seu CEP PERNOITE?
                        </Typography>
                        <Typography fontSize='.93rem' lineHeight='21px' paddingTop='1.81rem' color='error.main'>
                            Se esta alteração <b>também se aplica ao seu perfil</b>, ela altera a estrutura do seu seguro.
                            Ao realizar esta alteração, seu serviço será desativado e você <b>precisará</b> entrar em contato
                            com nossa <b>Central de Atendimento</b> com urgência para regularização.
                        </Typography>
                    </Box>
                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        padding: '1.875rem 3.81rem 1.75rem',
                        backgroundColor: 'primary.main',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                        }
                    }}>
                        <ButtonRectangle name='NÃO SE APLICA' onClick={() => { handlePostEditCustomerAppAddressState({ flPerfil: false }); setShowModal(false); }} />
                        <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                            <ButtonOutlined name='APLICAR AO PERFIL' onClick={() => { handlePostEditCustomerAppAddressState({ flPerfil: true }); setShowModal(false); }} />
                        </Box>
                    </Box>
                </Box>
            </Modals>

            <Modals open={showModalSuccess}>
                <Box sx={{ textAlign: 'center', width: '23.31rem' }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 0 1.125rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700}>
                            SUCESSO
                        </Typography>
                        <Typography fontSize='.93rem' lineHeight='21px' paddingTop='.875rem'>
                            Em breve nossa <strong>Central de Atendimento</strong><br />
                            entrará em contato para falar sobre esta alteração!
                        </Typography>
                    </Box>
                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        padding: '1.875rem 3.81rem 1.75rem',
                        backgroundColor: 'primary.main',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                        }
                    }}>
                        <ButtonRectangle name='FECHAR' onClick={() => { setShowModalSuccess(false); handleResetUpdatePerfil(); }} />
                    </Box>
                </Box>
            </Modals>

            <Modals open={showModalError}>
                <Box sx={{ textAlign: 'center', width: '23.31rem' }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 0 1.125rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700}>
                            ATENÇÃO!
                        </Typography>
                        <Typography fontSize='.93rem' lineHeight='21px' paddingTop='.875rem'>
                            {msgModalError}
                        </Typography>
                    </Box>
                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        padding: '1.875rem 3.81rem 1.75rem',
                        backgroundColor: 'primary.main',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                        }
                    }}>
                        <ButtonRectangle name='FECHAR' onClick={() => setShowModalError(false)} />
                    </Box>
                </Box>
            </Modals>

            <Modals open={showModalDeleted.show}>
                <Box sx={{ textAlign: 'center', width: '23.31rem' }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 0 1.125rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700}>
                            ATENÇÃO!
                        </Typography>
                        <Typography fontSize='.93rem' lineHeight='21px' paddingTop='.875rem'>
                            Deseja remover este endereço?
                        </Typography>
                    </Box>
                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        padding: '1.875rem 3.81rem 1.75rem',
                        backgroundColor: 'primary.main',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                        }
                    }}>
                        <ButtonRectangle name='DELETAR' onClick={() => {
                            setValue(`deleted${showModalDeleted.indexDeleted}`, true);
                            setShowModalDeleted({ show: false, indexDeleted: 0, });
                            setLengthDelete(lengthDelete - 1);
                        }} />
                        <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                            <ButtonOutlined name='CANCELAR' onClick={() => setShowModalDeleted({ show: false, indexDeleted: 0, })} />
                        </Box>
                    </Box>
                </Box>
            </Modals>
        </Box >
    );
}

export default BillingAddress;